import React from 'react';

const Errors = () => (
  <div style={{textAlign: 'center'}}>
    <h2>{'Bad Request.'}</h2>
  </div>
);

export default Errors;
